import { render } from "./ContactFile.vue?vue&type=template&id=24599c3a"
import script from "./ContactFile.vue?vue&type=script&lang=ts"
export * from "./ContactFile.vue?vue&type=script&lang=ts"

import "./ContactFile.vue?vue&type=style&index=0&id=24599c3a&lang=scss"
script.render = render

export default script